import React, { useRef, useState } from "react";
import AppContainer from "../../../components/AppContainer";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import { Grid, MenuItem, Stack, Typography } from "@mui/material";
import ImageUploader from "../../../components/ImageUploader";
import Label from "../../../components/Label";
import TextInput from "../../../components/TextInputs";
import globalStyle from "../../../globalStyle";
import { DatePicker } from "@mui/x-date-pickers";
import CustomDropDown from "../../../components/CutomDropDown";
import GlobalButton from "../../../components/CustomButton";
import PhoneInput from "react-phone-input-2";
import AddEditAddress from "./AddEditUserAddress";
import appcolors from "../../../constants/Colors";
import VerifyConfirmDialog from "../../../components/Dialog/VerifyConfirmDialog";
import SnackbarAlert from "../../../components/SnackBar";

function AddUsers() {
  const openDialog = useRef(null);
  const openConfirmDialog = useRef(null);
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState({
    images: "",
  });
  const activeTab = useSelector((state) => state.activeTab.tabs);

  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, clientUsers: "clientList" }));
  };

  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  const handleImageUpload = (url) => {
    setInputValue((prev) => ({
      ...prev,
      images: url,
    }));

    handleSnackbarVal(true, "success", "Image uploaded successfully");
  };

  const renderRightPart = () => {
    return (
      <Stack
        gap={1}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <GlobalButton
          variant={"contained"}
          btnText={"Save"}
          handleClickBtn={handleChangeTab}
          styleProps={{
            fontWeight: 400,
            fontSize: "0.875rem",
            height: 40,
            width: 120,
          }}
        />
      </Stack>
    );
  };

  return (
    <>
      <AppContainer
        primaryHeading={"Create new client"}
        secondaryHeading={"Please enter all details"}
        headProps={renderRightPart()}
        showBackButton
        handleBack={handleChangeTab}
        childrenProps={{
          sx: {
            padding: { xs: "10px 20px", md: "20px 50px" },
            paddingBottom: "50px !important",
          },
        }}
      >
        <Typography my={1} variant="h1" fontSize={"1.125rem"} fontWeight={600}>
          Services and sessions
        </Typography>

        <ImageUploader
          image={inputValue?.images}
          onUploadSuccess={handleImageUpload}
          handleSnackbarVal={handleSnackbarVal}
        />

        <Grid container my={2} spacing={2}>
          <Grid item xs={12} md={5}>
            <Label labelText="First name" required />
            <TextInput styleProps={globalStyle.textField} />
          </Grid>
          <Grid item xs={12} md={5}>
            <Label labelText="Lat name" required />
            <TextInput styleProps={globalStyle.textField} />
          </Grid>
          <Grid item xs={12} md={5}>
            <Label labelText="Email" required />
            <TextInput styleProps={globalStyle.textField} />
          </Grid>
          <Grid item xs={12} md={5}>
            <Label labelText="Contact number" required />
            <PhoneInput
              country={"us"}
              inputClass="cutom-phone-input-grey"
              buttonClass="custom-phone-input-button"
              onChange={(phone) => console.log(phone, "sdsdsadasdasdasdas")}
            />
          </Grid>
          <Grid item xs={12} md={5}>
            <Label labelText="Birthday" required />
            <DatePicker sx={{ width: "100%", ...globalStyle.textField }} />
          </Grid>
          <Grid item xs={12} md={2}>
            <Label labelText="Gender" required />
            <CustomDropDown size={"small"} variant={"outlined"}>
              <MenuItem value={"Male"}>Male</MenuItem>
              <MenuItem value={"Female"}>Female</MenuItem>
            </CustomDropDown>
          </Grid>
          <Grid item xs={12}>
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Label labelText="Address" required />
              <Typography
                variant="body2"
                color={appcolors.slateGrey}
                sx={{ cursor: "pointer" }}
                onClick={() => openDialog.current.isVisible()}
              >
                Set Address
              </Typography>
            </Stack>
            <TextInput styleProps={globalStyle.textField} />
          </Grid>
        </Grid>
        <Typography variant="h1" fontSize={"1.125rem"} fontWeight={600}>
          Additional information
        </Typography>

        <Grid container my={1} spacing={2}>
          <Grid item xs={12} md={5}>
            <Label labelText="Language" required />
            <CustomDropDown size={"small"}>
              <MenuItem value={"English"}>English</MenuItem>
              <MenuItem value={"Arabic"}>Arabic</MenuItem>
            </CustomDropDown>
          </Grid>
          <Grid item xs={12} md={5}>
            <Label labelText="Client source" required />
            <TextInput styleProps={globalStyle.textField} />
          </Grid>
        </Grid>
      </AppContainer>
      <AddEditAddress ref={openDialog} />
      <VerifyConfirmDialog ref={openConfirmDialog} />
      <SnackbarAlert
        snackbarProps={snackbarProps}
        handleCloseSnackbar={handleCloseSnackbar}
      />
    </>
  );
}

export default AddUsers;
